import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Http, Response, Headers } from '@angular/http';
import * as myGlobals from '../globals';
import 'rxjs/add/operator/catch';
import 'rxjs/Rx';
import { ConfigService } from '../config.service';

export class User {
    constructor() { }
}

@Injectable()
export class DispatcherService {
    private _zoneUrl = myGlobals.configurl + 'operationalZone';
    private _addinfoUrl = myGlobals.slaveurl + 'livebooking';
    private _cancelservice = myGlobals.apiurl + 'slave/cancelBooking';
    private _fileUpload = '';
    private _allzones = '';
    private _getdrivers = myGlobals.slaveurl + 'Drivers';
    private _dispatcherLivepath = myGlobals.dispatchurl + 'tasks/livePath/';
    private _pending_reff = myGlobals.slaveurl + 'pendingratings';
    private _submitreasons = myGlobals.apiurl + "app/submitreview";
    private _paymentSettings = myGlobals.apiurl + "customer/paymentSetting";

    // UBER FOR ALL APIS LIST ------------------------------------>

    private _appconfig = myGlobals.apiurl + 'customer/appConfig/3';
    private _logout = myGlobals.apiurl + "customer/signOut";
    private _vehiclesList = myGlobals.apiurl + 'customer/drivers';
    private _shipmentfareUrl = myGlobals.apiurl + 'customer/fareEstimate';
    private _paymentSetting = myGlobals.apiurl + "customer/paymentSetting";
    private _booknow = myGlobals.apiurl + "customer/book";
    private _getcards = myGlobals.apiurl + 'customer/card';
    private _addcards = myGlobals.apiurl + 'customer/card';
    private _deletecards = myGlobals.apiurl + 'customer/card';
    private _changecards = myGlobals.apiurl + 'customer/card';
    private _checkcreditlimit = myGlobals.apiurl + 'customer/creditLimit';
    private _rechargeWallet = myGlobals.apiurl + 'customer/rechargeWallet';
    private _wallet_transactions = myGlobals.apiurl + "customer/walletTransaction";
    private _wallet_details = myGlobals.apiurl + "customer/walletDetail";
    private _profile = myGlobals.apiurl + 'customer/profile';
    private _cancelBooking = myGlobals.apiurl + 'customer/cancelBookingBeforeAccept';
    private _getCorporate = myGlobals.apiurl + 'customer/institute/user/accounts';
    private _verifyCorporate = myGlobals.apiurl + 'customer/institute/user/officialEmailVerification';
    private _verifyPromocode = myGlobals.apiurl + 'customer/promoCodeValidation';
    private _checkLastDue = myGlobals.apiurl + 'customer/lastDue';
    private _preferance = myGlobals.apiurl + 'customer/preferences';

    constructor(
        private _router: Router,
        private _http: Http,
        private _cookie: ConfigService) { }

    // UBER FOR ALL API CALLS --------------------------------------->

    // check last due
    lastDue(user: any) {
        return this._http.get(this._checkLastDue, { headers: this._cookie.header })
            .map(res => res.json())
            .map((res) => {
                return res;
            })
    }

    preference(user: any) {
        return this._http.get(this._preferance + '/' + user.cityId + '/' + user.typeId + '/' + user.serviceType, { headers: this._cookie.header })
            .map(res => res.json())
            .map((res) => {
                return res;
            })
    }

    verifypromo(user: any) {
        let body = JSON.stringify(user);
        return this._http.post(this._verifyPromocode, body, { headers: this._cookie.header })
            .map(res => res.json())
            .map((res) => {
                console.log(res);
                return res;
            })
    }

    appconfig(user: any) {
        return this._http.get(this._appconfig, { headers: this._cookie.header })
            .map(res => res.json())
            .map((res) => {
                return res;
            })
    }

    // GET ALL THE VEHICLE TYPES
    vehicles(user: any) {
        let body = JSON.stringify(user);
        return this._http.get(this._vehiclesList + '/' + user.lt + '/' + user.lg + '/' + this._cookie.getItem('mqttTopic') + '/' + 1 + '/' + 2, { headers: this._cookie.header })
            .map(res => res.json())
            .map((res) => {
                return res;
            })
    }

    paymentDetails(user: any) {
        let body = JSON.stringify(user);
        return this._http.get(this._paymentSetting, { headers: this._cookie.header })
            .map(res => res.json())
            .map((res) => {
                return res;
            })
    }

    booknowRide(user: any) {
        let body = JSON.stringify(user);
        return this._http.post(this._booknow, body, { headers: this._cookie.header })
            .map(res => res.json())
            .map((res) => {
                if (res.data.token) {
                    this._cookie.setItem(res.data.token);
                }
                return res;
            })
    }

    // add cards
    cancelBooking(user: any) {
        let body = JSON.stringify(user);
        return this._http.put(this._cancelBooking, body, { headers: this._cookie.header })
            .map(res => res.json())
            .map((res) => {
                return res;
            })
    }

    // GETTING ALL THE CARDS ADDED 
    getcards(user: any) {
        let body = JSON.stringify(user);
        return this._http.get(this._getcards, { headers: this._cookie.header })
            .map(res => res.json())
            .map((res) => {
                return res;
            })
    }

    // add cards
    addcards(user: any) {
        let body = JSON.stringify(user);
        return this._http.post(this._addcards, body, { headers: this._cookie.header })
            .map(res => res.json())
            .map((res) => {
                return res;
            })
    }

    // change cards
    changecards(user: any) {
        let body = JSON.stringify(user);
        return this._http.patch(this._changecards, body, { headers: this._cookie.header })
            .map(res => res.json())
            .map((res) => {
                return res;
            })
    }

    // delete cards
    deletecard(user: any) {
        let body = JSON.stringify(user);
        return this._http.delete(this._deletecards, { headers: this._cookie.header, body })
            .map(res => res.json())
            .map((res) => {
                return res;
            })
    }

    // GET credit limit for booking
    creditlimit(user: any) {
        let body = JSON.stringify(user);
        return this._http.get(this._checkcreditlimit, { headers: this._cookie.header })
            .map(res => res.json())
            .map((res) => {
                return res;
            })
    }

    // recharge wallet from wallet component
    recharge(user: any) {
        let body = JSON.stringify(user);
        return this._http.post(this._rechargeWallet, body, { headers: this._cookie.header })
            .map(res => res.json())
            .map((res) => {
                return res;
            })
    }

    // get wallet details
    wallet(user: any) {
        let body = JSON.stringify(user);
        return this._http.get(this._wallet_details, { headers: this._cookie.header })
            .map(res => res.json())
            .map((res) => {
                return res;
            })
    }

    // GET wallet transactions for wallet page
    wallettrans(user: any) {
        let body = JSON.stringify(user);
        return this._http.get(this._wallet_transactions + '/' + user.pageIndex, { headers: this._cookie.header })
            .map(res => res.json())
            .map((res) => {
                return res;
            })
    }

    // GET PROFILE
    profile(user: any) {
        let body = JSON.stringify(user);
        return this._http.get(this._profile, { headers: this._cookie.header })
            .map(res => res.json())
            .map((res) => {
                return res;
            })
    }

    // START OF CORPORATE ACCOUNT

    getcorporate(user: any) {
        return this._http.get(this._getCorporate, { headers: this._cookie.header })
            .map(res => res.json())
            .map((res) => {
                return res;
            })
    }

    // add cards
    verifycorporate(user: any) {
        let body = JSON.stringify(user);
        return this._http.post(this._verifyCorporate, body, { headers: this._cookie.header })
            .map(res => res.json())
            .map((res) => {
                return res;
            })
    }

    // END OF CORPORATE ACCOUNT


    // END OF UBER FOR ALL API CALLS --------------------------------------->


    // GET PROFILE

    payment(user: any) {
        let body = JSON.stringify(user);
        return this._http.get(this._paymentSettings, { headers: this._cookie.header })
            .map(res => res.json())
            .map((res) => {
                return res;
            })
    }

    // CALCULATION OF SURGE PRICING IN ADDNEW FORM FOR DISTANCE

    surgeprice(user: any) {
        let body = JSON.stringify(user);
        return this._http.post(this._shipmentfareUrl, body, { headers: this._cookie.header })
            .map(res => res.json())
            .map((res) => {
                if (res.data.token) {
                    this._cookie.setItem(res.data.token);
                }
                return res;
            })
    }


    // ZONE VALIDATION FOR ADD NEW FORM

    zone(user: any) {
        let body = JSON.stringify(user);
        let headers = new Headers();
        headers.append('Content-Type', 'application/json');
        return this._http.post(this._zoneUrl, body, { headers: headers })
            .map(res => res.json())
            .map((res) => {
                return res;
            })
    }

    // ADD NEW BOOKING API----------------------------------------------------

    addinfo(user: any) {
        let body = JSON.stringify(user);
        let headers = new Headers();
        headers.append('authorization', sessionStorage.getItem("authtoken"));
        headers.append('Content-Type', 'application/json');
        return this._http.post(this._addinfoUrl, body, { headers: headers })
            .map(res => res.json())
            .map((res) => {
                return res;
            })

    }

    // CANCEL BOOKING BY PASSING BOOKING ID  ----------------------------------------------------
    cancelservice(user: any) {
        let body = JSON.stringify(user);
        let headers = new Headers();
        headers.append('Content-Type', 'application/json');
        headers.append('authorization', sessionStorage.getItem("authtoken"));
        return this._http.post(this._cancelservice, body, { headers: headers })
            .map(res => res.json())
            .map((res) => {
                if (res.token) {

                }
                return res;
            })

    }

    //LOGOUT SERVICE 

    loggedout(user: any) {
        let body = JSON.stringify(user);
        return this._http.post(this._logout, body, { headers: this._cookie.header })
            .map(res => res.json())
            .map((res) => {
                return res;
            })
    }

    // GET PENDING REFERRALS

    pendingRef(user: any) {
        let body = JSON.stringify(user);
        let headers = new Headers();
        headers.append('authorization', sessionStorage.getItem("authtoken"));
        return this._http.get(this._pending_reff, { headers: headers })
            .map(res => res.json())
            .map((res) => {
                return res;
            })
    }
    // update PROFILE

    updateprofile(user: any) {
        let body = JSON.stringify(user);
        let headers = new Headers();
        headers.append('authorization', sessionStorage.getItem("authtoken"));
        return this._http.put(this._profile, body, { headers: headers })
            .map(res => res.json())
            .map((res) => {
                return res;
            })
    }

    // GETTING ALL ZONES FOR PREPARING BULK UPLOAD IT CONVERTS TO TXT FORMAT AND DOWNLOAD

    allzones(user: any) {
        let body = JSON.stringify(user);
        let headers = new Headers();
        return this._http.get(this._allzones, { headers: headers })
            .map(res => res.json())
            .map((res) => {
                return res;
            })
    }

    // GETTING ALL THE DRIVERS LIST 
    getdrivers(user: any) {
        let body = JSON.stringify(user);
        let headers = new Headers();
        headers.append('authorization', sessionStorage.getItem("authtoken"));
        return this._http.get(this._getdrivers + '/' + user.lt + '/' + user.lg + '/' + sessionStorage.getItem('chn') + '/' + sessionStorage.getItem('presence'), { headers: headers })

            .map(res => res.json())
            .map((res) => {
                return res;
            })
    }

    // GET review reasons based on rating
    submitereivew(user: any) {
        let body = JSON.stringify(user);
        let headers = new Headers();
        headers.append('authorization', sessionStorage.getItem("authtoken"));
        return this._http.post(this._submitreasons, body, { headers: headers })
            .map(res => res.json())
            .map((res) => {
                return res;
            })
    }
}


// WEBPACK FOOTER //
// F:/Karry/Zoom/ZoomCustomer/src/app/dispatcher/dispatcher.service.ts